<template>
  <v-container fill-height fluid>
    <v-row
      align="center"
      justify="center"
      v-if="
        $vuetify.breakpoint.name == 'lg' ||
        $vuetify.breakpoint.name == 'xl' ||
        $vuetify.breakpoint.name == 'md'
      "
    >
      <v-icon size="100" color="error">mdi-alert</v-icon>
      <v-divider vertical class="mx-5"></v-divider>
      <h2>THE PAGE YOU REQUESTED WAS NOT FOUND</h2>
    </v-row>

    <v-row align="center" justify="center" v-else>
      <v-col cols="12" class="mx-auto">
        <v-row align="center" justify="center">
          <v-icon size="100" color="error">mdi-alert</v-icon>
        </v-row>
      </v-col>
      <v-col cols="12" class="text-center">
        <v-divider class="my-3"></v-divider>
        <h2>THE PAGE YOU REQUESTED WAS NOT FOUND</h2>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({}),
};
</script>
